import type { BatchJobKindView } from "../../batch_job_kind_contract";
import { DocumentSectionsRefreshPanel } from "./DocumentSectionsRefreshPanel";

export { DocumentSectionsRefreshParamsForm } from "./DocumentSectionsRefreshParamsForm";
export { useDocumentSectionsRefreshParams } from "./useDocumentSectionsRefreshParams";
export type { UseDocumentSectionsRefreshParamsResult } from "./useDocumentSectionsRefreshParams";

export const DOCUMENT_SECTIONS_REFRESH_VIEW: BatchJobKindView = {
  label: "Document sections refresh",
  Panel: DocumentSectionsRefreshPanel,
};
